export const ROLE_OWNER = 'owner';
export const ROLE_ADMIN = 'admin';
export const ROLE_TEACHER = 'teacher';
export const ROLE_PROGRAM_MANAGER = 'programManager';
export const ROLE_PROGRAM_TRAINER = 'programTrainer';
export const ROLE_STUDENT = 'student';

export const rolesEnum = {
  [ROLE_OWNER]: 'Owner',
  [ROLE_ADMIN]: 'Admin',
  [ROLE_TEACHER]: 'Teacher',
  [ROLE_PROGRAM_MANAGER]: 'Program Manager',
  [ROLE_PROGRAM_TRAINER]: 'Program Trainer',
  [ROLE_STUDENT]: 'Student'
};
